export default __webpack_public_path__ + "static/media/factory-of-the-future-leadership-training.d3503185.svg";